export default __webpack_public_path__ + "static/media/sort.7a1195e2.svg";